import {queries} from '@/shared/integrations/zero'
import {FLAGS} from '@/shared/constants'
import {ListCompoundMappingsInput} from '@cypro/engine/queries'
import {useQuery} from '@rocicorp/zero/react'

export function useGetCompoundMappings(input: ListCompoundMappingsInput = {}) {
  return useQuery(queries.compounders.listCompoundMappings(input), {enabled: FLAGS.smartCompounder})
}
